var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthiquinInvestigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_path_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 270
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: 6.205,
    y1: 15.406,
    x2: 36.031,
    y2: 32.604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D7E1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#CBD5E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#B6C4CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFBEC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: 0.06,
    y1: 4.448,
    x2: 10.153,
    y2: 4.448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    stopColor: "#FDFDFE",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#F6F7FA",
    stopOpacity: 0.459
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708,
    stopColor: "#EAECF2",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#D8DDE6",
    stopOpacity: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#C2CBD8",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C9D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: 30.806,
    y1: 14.992,
    x2: -6.762,
    y2: 33.356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D7E1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C9D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: -0.021,
    y1: 4.448,
    x2: 10.072,
    y2: 4.448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#C0C9D7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#C2CBD8",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#D8DDE6",
    stopOpacity: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#EAECF2",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#F6F7FA",
    stopOpacity: 0.459
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FDFDFE",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 12.962,
    y1: -0.026,
    x2: 12.962,
    y2: 25.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#099CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#1090C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#1D6998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#204C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#20385C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#1E294B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#1C2040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#1A1C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1B39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 17.252,
    y1: 38.216,
    x2: 27.701,
    y2: -0.78
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8C6A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#936C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#AB6F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#BD703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#C77033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#CB7031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#CC7435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#CD7D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#D08C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#D3A177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3A57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_8",
    gradientUnits: "userSpaceOnUse",
    x1: 20.767,
    y1: 38.232,
    x2: 10.318,
    y2: -0.765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8C6A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#936C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#AB6F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#BD703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#C77033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#CB7031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#CC7435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#CD7D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#D08C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#D3A177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3A57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_9",
    gradientUnits: "userSpaceOnUse",
    x1: 10.182,
    y1: 0.585,
    x2: 10.182,
    y2: 27.713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A2D7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#7DB0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5F90C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#4E7CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4875B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_10",
    gradientUnits: "userSpaceOnUse",
    x1: 53.817,
    y1: 0.023,
    x2: 53.817,
    y2: 94.789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#D7E1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#CFDBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0CFE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_11",
    gradientUnits: "userSpaceOnUse",
    x1: 44.475,
    y1: -0.016,
    x2: 44.475,
    y2: 55.745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1D3E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#102C43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_12",
    gradientUnits: "userSpaceOnUse",
    x1: 10.75,
    y1: 7.971,
    x2: 10.75,
    y2: -0.009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8C6A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#936C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#AB6F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#BD703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#C77033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#CB7031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#CC7435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#CD7D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#D08C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#D3A177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3A57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_13",
    gradientUnits: "userSpaceOnUse",
    x1: 50.255,
    y1: 54.029,
    x2: 50.255,
    y2: 0.02
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8C6A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#936C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#AB6F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#BD703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#C77033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#CB7031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#CC7435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#CD7D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#D08C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#D3A177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3A57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_14",
    gradientUnits: "userSpaceOnUse",
    x1: 42.639,
    y1: 25.182,
    x2: 42.639,
    y2: -0.017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8C6A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#936C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106,
    stopColor: "#AB6F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#BD703A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#C77033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#CB7031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#CC7435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#CD7D42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#D08C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976,
    stopColor: "#D3A177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3A57D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_15",
    gradientUnits: "userSpaceOnUse",
    x1: 14.384,
    y1: 28.635,
    x2: 14.384,
    y2: -0.019
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F09925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#F1A130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#F5B54B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#F6C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_16",
    gradientUnits: "userSpaceOnUse",
    x1: 39.367,
    y1: 91.646,
    x2: 39.367,
    y2: 0.023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16263F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#1A2C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#283C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#2C4159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#2F435D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#374B67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405370"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_17",
    gradientUnits: "userSpaceOnUse",
    x1: 98.745,
    y1: 197.427,
    x2: 98.745,
    y2: -0.008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F09925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#F3AB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#F6BE57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C561"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_18",
    gradientUnits: "userSpaceOnUse",
    x1: -0.011,
    y1: 86.397,
    x2: 172.77,
    y2: 86.397
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F09925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#F1A130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#F5B54B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#F6C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C561"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_path_1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.874 18.252)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.408 118.998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1703 16.4302C24.7183 35.6002 26.2303 40.1902 19.8043 43.5382C19.0483 43.9162 15.2683 45.9142 10.6243 45.4282C6.89832 45.0502 4.09031 43.2682 2.90231 42.1882C-4.44169 35.4922 2.84831 18.5362 16.9423 7.14221C19.4803 5.09022 25.6903 -1.11978 29.9563 0.176215C31.6843 0.716215 32.4943 2.28221 33.0343 3.41621C35.3563 8.43821 33.3043 13.5682 32.1703 16.4302C32.1703 16.4302 32.1703 16.4302 32.1703 16.4302Z",
    fill: "url(#gradient_2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.399191 0.0405064C2.45119 1.17451 4.28719 2.47051 6.01519 3.92851C7.74319 5.38652 9.09319 6.95252 10.0652 8.51851C10.1192 8.62652 10.1192 8.78852 9.95719 8.84252C9.84919 8.89652 9.68719 8.89652 9.63319 8.78852C8.66119 7.22252 7.36519 5.76451 5.69119 4.30652C4.01718 2.84851 2.12718 1.60652 0.129183 0.472517C0.0211844 0.418512 -0.0328188 0.256519 0.0211844 0.148514C0.0751877 0.0945091 0.129183 0.0405064 0.237181 0.0405064C0.345188 -0.0134964 0.399191 -0.0134964 0.399191 0.0405064",
    fill: "url(#gradient_3)",
    fillRule: "evenodd",
    transform: "translate(2.449 25.462)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.658 2.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92401 16.4302C9.37601 35.6002 7.86401 40.1902 14.29 43.5382C15.046 43.9162 18.826 45.9142 23.47 45.4282C27.196 45.0502 30.004 43.2682 31.192 42.1882C38.536 35.4922 31.246 18.5362 17.152 7.14221C14.614 5.09022 8.404 -1.11978 4.138 0.176215C2.40999 0.716215 1.59999 2.28221 1.05999 3.41621C-1.26198 8.43821 0.79001 13.5142 1.92401 16.4302C1.92401 16.4302 1.92401 16.4302 1.92401 16.4302Z",
    fill: "url(#gradient_4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6983 0.0405064C7.6463 1.17451 5.81029 2.47051 4.0823 3.92851C2.35429 5.38652 1.00429 6.95252 0.032299 8.51851C-0.0217037 8.62652 -0.0217037 8.78852 0.140306 8.84252C0.248314 8.89652 0.410307 8.89652 0.46431 8.78852C1.4363 7.22252 2.73232 5.76451 4.4063 4.30652C6.08031 2.84851 7.97031 1.60652 9.9683 0.472517C10.0763 0.418512 10.1303 0.256519 10.0763 0.148514C10.0223 0.0945091 9.9683 0.0405064 9.86031 0.0405064C9.80629 -0.0134964 9.75228 -0.0134964 9.6983 0.0405064",
    fill: "url(#gradient_5)",
    fillRule: "evenodd",
    transform: "translate(21.71 25.462)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.678 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.722 57.5817L34.722 53.4777L27.972 53.4777C27.972 53.4777 27.972 57.4737 27.972 57.4737C21.168 57.4197 0 50.7237 0 50.7237C0 50.7237 3.618 13.3557 12.69 5.68775C15.498 3.31175 18.9 1.74575 20.142 1.31374C24.57 -0.252252 28.458 0.0177484 31.05 0.0177484C31.05 0.0177484 31.482 0.0177484 31.482 0.0177484C34.074 0.0177484 37.962 -0.252252 42.39 1.31374C43.578 1.74574 47.574 2.77175 49.842 5.68775C58.914 17.6758 63.45 50.7237 63.45 50.7237C63.45 50.7237 41.526 57.6357 34.722 57.5817C34.722 57.5817 34.722 57.5817 34.722 57.5817Z",
    fill: "#D7E1EF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.773 8.904)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.7231 11.3098C27.1811 20.6518 19.6211 28.5898 10.7651 27.0778C5.41912 26.1598 1.09912 21.5698 0.18111 15.9538C-1.2769 6.6118 6.2831 -1.3262 15.1391 0.18579C20.4851 1.1038 24.8051 5.63979 25.7231 11.3098C25.7231 11.3098 25.7231 11.3098 25.7231 11.3098Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7231 10.9903C27.1811 20.0083 19.6211 27.7303 10.7651 26.2183C5.41912 25.3003 1.09912 20.9263 0.18111 15.4183C-1.2769 6.40029 6.2831 -1.3217 15.1391 0.190289C20.4851 1.16228 24.8051 5.53628 25.7231 10.9903C25.7231 10.9903 25.7231 10.9903 25.7231 10.9903Z",
    fill: "#486494",
    fillRule: "evenodd",
    fillOpacity: 0.95,
    transform: "translate(0 0.805)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7231 10.6053C27.1811 19.3533 19.6211 26.8053 10.7651 25.3473C5.41912 24.4833 1.09912 20.2173 0.18111 14.9253C-1.2769 6.17734 6.2831 -1.27466 15.1391 0.183351C20.4851 0.993351 24.8591 5.31335 25.7231 10.6053C25.7231 10.6053 25.7231 10.6053 25.7231 10.6053Z",
    fill: "url(#gradient_6)",
    fillRule: "evenodd",
    transform: "translate(0 1.73)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.746 3.318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.18C0 4.11003 4.08585 0 9.126 0C14.1662 0 18.252 4.11003 18.252 9.18C18.252 14.25 14.1662 18.36 9.126 18.36C4.08585 18.36 0 14.25 0 9.18Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(0 1.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18 15.174L3.13199 6.04801L9.18 11.34C9.18 11.34 16.524 3.834 16.524 3.834C14.85 1.51201 12.15 0 9.126 0C4.05 0 0 4.104 0 9.18C0 14.256 4.104 18.36 9.126 18.36C14.202 18.36 18.252 14.256 18.252 9.18C18.252 7.56 17.82 5.994 17.064 4.69801C17.064 4.69801 9.18 15.174 9.18 15.174L9.18 15.174ZM9.17988 3.77995C10.3679 3.77995 11.2859 4.75195 11.2859 5.93995C11.2859 7.12796 10.3679 8.09995 9.17988 8.09995C7.99188 8.09995 7.07389 7.12796 7.07389 5.93995C7.07387 4.75196 8.04588 3.77995 9.17988 3.77995",
    fill: "#099CD8",
    transform: "translate(0 1.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.346 0C5.346 0 0 5.454 0 5.454C0.215996 5.724 0.378006 6.04801 0.540001 6.31801C0.540001 6.31801 5.346 0 5.346 0L5.346 0Z",
    fill: "#099CD8",
    fillRule: "evenodd",
    transform: "translate(16.47 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0.129183 5.94C0.021184 5.994 -0.0328188 6.156 0.021184 6.264C0.0751877 6.37201 0.237181 6.42599 0.345188 6.37201C7.52719 2.484 14.6552 0.486013 21.7832 0.486013C28.9112 0.486013 36.0932 2.43002 43.2212 6.37201C43.3292 6.42601 43.4912 6.37201 43.5452 6.264C43.5992 6.156 43.5452 5.994 43.4372 5.94C36.2012 1.99801 28.9652 0 21.7292 0C14.5472 0.0540032 7.31119 1.99801 0.129183 5.94",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(9.321 6.876)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.996 122.245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.482 1.03674L31.482 1.03674C31.482 1.03674 31.482 1.03674 31.482 1.03674C31.482 1.03674 31.374 0.658735 31.212 0.388735C31.05 0.226741 30.942 0.0647314 30.726 0.0107282C30.51 -0.0432752 30.294 0.118735 30.024 0.226725C21.87 4.70872 15.174 10.0007 15.174 10.0007C13.5 11.4047 11.88 12.9707 10.26 14.5367C8.586 16.1567 6.858 17.6147 5.13 19.1267C3.402 20.6387 0 23.9327 0 23.9327C9.342 41.5367 37.476 41.8607 37.476 41.8607C37.476 41.8607 40.014 34.4627 34.452 22.7987C34.398 22.8527 31.428 15.7247 31.482 1.03674C31.482 1.03674 31.482 1.03674 31.482 1.03674Z",
    fill: "url(#gradient_7)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57186 1.03674L6.57186 1.03674C6.57186 1.03674 6.57186 1.03674 6.57186 1.03674C6.57186 1.03674 6.67986 0.658735 6.84186 0.388735C7.00385 0.226741 7.11185 0.0647314 7.32786 0.0107282C7.54385 -0.0432751 7.75985 0.118735 8.02985 0.226725C16.1839 4.70872 22.8799 10.0007 22.8799 10.0007C24.5539 11.4047 26.1739 12.9707 27.7939 14.5367C29.4679 16.1567 31.1958 17.6147 32.9239 19.1267C34.6519 20.6387 38.0539 23.9327 38.0539 23.9327C28.7119 41.5367 0.577854 41.8607 0.577854 41.8607C0.577854 41.8607 -1.96015 34.4627 3.60186 22.7987C3.60186 22.8527 6.57186 15.7247 6.57186 1.03674C6.57186 1.03674 6.57186 1.03674 6.57186 1.03674Z",
    fill: "url(#gradient_8)",
    fillRule: "evenodd",
    transform: "translate(61.36 0.216)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.358 10.098C20.358 14.58 17.442 18.36 13.446 19.71C13.446 19.71 13.446 27.378 13.446 27.378L6.696 27.378C6.696 27.378 6.696 19.71 6.696 19.71C2.80799 18.306 0 14.526 0 10.098C0 4.428 4.536 0 10.152 0C15.822 0 20.358 4.428 20.358 10.098C20.358 10.098 20.358 10.098 20.358 10.098Z",
    fill: "url(#gradient_9)",
    fillRule: "evenodd",
    transform: "translate(43.632 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.838 0C24.084 0 0 24.138 0 53.838C0 53.838 0 63.882 0 63.882C0 80.946 13.824 94.716 30.834 94.716C30.834 94.716 76.842 94.716 76.842 94.716C93.906 94.716 107.676 80.892 107.676 63.882C107.676 63.882 107.676 53.838 107.676 53.838C107.676 24.138 83.538 0 53.838 0C53.838 0 53.838 0 53.838 0Z",
    fill: "url(#gradient_10)",
    fillRule: "evenodd",
    transform: "translate(0 27.216)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.342 51.084)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.0540033 40.014C0.0540033 50.544 8.586 59.076 19.116 59.076C19.116 59.076 69.822 59.076 69.822 59.076C80.352 59.076 88.884 50.544 88.884 40.014C88.884 40.014 88.884 26.244 88.884 26.244C88.884 11.772 77.166 0 62.64 0C62.64 0 26.244 0 26.244 0C11.772 0 0 11.718 0 26.244C0 26.244 0 40.014 0 40.014C0 40.014 0.0540033 40.014 0.0540033 40.014Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0540033 26.352C0.0540033 11.772 11.88 0 26.406 0C26.406 0 62.532 0 62.532 0C77.112 0 88.884 11.826 88.884 26.352C88.884 26.352 88.884 39.852 88.884 39.852C88.884 50.436 80.298 59.076 69.66 59.076C69.66 59.076 19.224 59.076 19.224 59.076C8.64 59.076 0 50.49 0 39.852C0 39.852 0.0540033 26.352 0.0540033 26.352C0.0540033 26.352 0.0540033 26.352 0.0540033 26.352Z",
    fill: "#486494",
    fillRule: "evenodd",
    transform: "translate(0 0.972)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0540033 26.352C0.0540033 11.772 11.88 0 26.406 0C26.406 0 62.532 0 62.532 0C77.112 0 88.884 11.826 88.884 26.352C88.884 26.352 88.884 36.558 88.884 36.558C88.884 47.142 80.298 55.782 69.66 55.782C69.66 55.782 19.224 55.782 19.224 55.782C8.64 55.782 0 47.196 0 36.558C0 36.558 0 26.352 0 26.352C0 26.352 0.0540033 26.352 0.0540033 26.352Z",
    fill: "url(#gradient_11)",
    fillRule: "evenodd",
    transform: "translate(0 4.32)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.6318 16.092C43.6318 18.9 45.8998 21.168 48.7078 21.168C48.7078 21.168 49.9498 21.168 49.9498 21.168C52.7578 21.168 55.0258 18.9 55.0258 16.092C55.0258 16.092 55.0258 5.076 55.0258 5.076C55.0258 2.268 52.7578 0 49.9498 0C49.9498 0 48.7078 0 48.7078 0C45.8998 0 43.6318 2.268 43.6318 5.076C43.6318 5.076 43.6318 16.092 43.6318 16.092C43.6318 16.092 43.6318 16.092 43.6318 16.092ZM0 16.092C0 18.9 2.268 21.168 5.076 21.168C5.076 21.168 6.318 21.168 6.318 21.168C9.126 21.168 11.394 18.9 11.394 16.092C11.394 16.092 11.394 5.076 11.394 5.076C11.394 2.268 9.126 0 6.318 0C6.318 0 5.076 0 5.076 0C2.268 0 0 2.268 0 5.076C0 5.076 0 16.092 0 16.092C0 16.092 0 16.092 0 16.092Z",
    fill: "#F4FAFE",
    fillRule: "evenodd",
    transform: "translate(16.957 20.466)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.566 28.566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8955 0C49.8955 0 49.8955 0.0540009 49.8955 0C50.1655 3.672 50.0575 6.26401 49.6255 7.938C49.6255 7.938 49.4635 8.532 49.4635 8.532C49.1395 9.82799 49.1395 9.82799 48.8695 10.476C48.8695 10.476 48.7075 10.854 48.7075 10.854L49.2475 10.854C49.2475 10.854 49.3015 10.692 49.3015 10.692C49.5715 9.99002 49.5715 9.99002 49.8955 8.694C49.8955 8.694 50.0575 8.1 50.0575 8.1C50.5435 6.318 50.5975 3.78 50.3275 0C50.3275 0 49.8955 0 49.8955 0C49.8955 0 49.8955 0 49.8955 0ZM0.593657 0C0.593657 0 0.593657 0.0540009 0.593657 0C0.323657 3.672 0.431655 6.26401 0.863657 7.938C0.863657 7.938 1.02566 8.532 1.02566 8.532C1.34966 9.82799 1.34966 9.82799 1.61966 10.476C1.61966 10.476 1.78166 10.854 1.78166 10.854L1.24166 10.854C1.24166 10.854 1.18766 10.692 1.18766 10.692C0.91766 9.99002 0.91766 9.99002 0.593657 8.694C0.593657 8.694 0.431655 8.1 0.431655 8.1C-0.0543411 6.318 -0.108344 3.78 0.161656 0C0.161656 0 0.593657 0 0.593657 0C0.593657 0 0.593657 0 0.593657 0Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(0 82.566)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3988 0.432002C-0.589166 8.1 0.0048285 23.274 0.0048285 23.436C0.0048285 23.436 0.0048285 23.436 0.0048285 23.436C0.0048285 23.436 0.544828 23.328 0.544828 23.328C0.490825 22.032 0.490825 6.912 13.1268 0C13.1268 0 12.4248 0.162002 12.4248 0.162002L11.3988 0.432002C11.3988 0.432002 11.3988 0.432002 11.3988 0.432002ZM38.6686 0.432002C50.6566 8.1 50.0626 23.274 50.0626 23.436C50.0626 23.436 50.0626 23.436 50.0626 23.436C50.0626 23.436 49.5226 23.328 49.5226 23.328C49.5766 22.032 49.5766 6.912 36.9406 0C36.9406 0 37.6426 0.162002 37.6426 0.162002L38.6686 0.432002C38.6686 0.432002 38.6686 0.432002 38.6686 0.432002Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(0.211 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.64 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.746 0C1.72799 0 0 7.992 0 7.992C0 7.992 10.746 7.992 10.746 7.992C10.746 7.992 21.492 7.992 21.492 7.992C21.492 7.992 19.764 0 10.746 0C10.746 0 10.746 0 10.746 0Z",
    fill: "url(#gradient_12)",
    fillRule: "evenodd",
    transform: "translate(39.506 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9576 37.962C16.5556 39.528 13.1536 41.148 10.1296 43.47C9.26556 44.118 8.40157 44.82 7.59157 45.522C7.59157 45.522 5.75557 47.142 5.37756 48.006C5.37756 48.006 4.78356 50.706 4.29756 52.002C3.86556 52.974 2.83956 53.838 1.81356 54C0.625561 54.162 0.19356 53.028 0.0855615 51.948C-0.0764401 50.652 0.0315582 49.248 0.0855615 47.952C0.517563 41.688 2.83956 35.532 5.97156 30.294C6.83556 28.782 7.86156 27.378 8.99556 26.136C9.10356 26.028 9.15756 25.974 9.26556 25.866C9.80556 25.11 10.5076 24.462 11.2636 23.922C11.2636 23.922 11.5876 23.76 11.9656 23.112C13.7476 19.926 15.9076 16.902 18.3916 14.31C21.5236 11.016 25.3576 8.37 29.2456 6.156C33.1336 3.942 37.2916 2.268 41.6116 1.134C46.2556 -0.0540013 46.2556 0.0539994 50.1435 0C50.1435 0 50.3595 0 50.3595 0C54.7875 0.162 54.1935 -0.0539994 58.8375 1.134C63.1576 2.214 67.3156 3.942 71.2035 6.156C75.0916 8.37 78.8716 11.016 82.0575 14.31C84.5415 16.902 86.7015 19.872 88.4835 23.112C88.8615 23.76 89.1855 23.922 89.1855 23.922C89.8875 24.462 90.5895 25.11 91.1835 25.866C91.2915 25.974 91.3455 26.028 91.4535 26.136C92.6415 27.378 93.6135 28.782 94.4775 30.294C97.6095 35.532 99.9315 41.688 100.364 47.952C100.472 49.248 100.526 50.652 100.364 51.948C100.256 53.028 99.8235 54.162 98.6355 54C97.6095 53.838 96.5835 53.028 96.1515 52.002C95.6115 50.706 95.0715 48.006 95.0715 48.006C94.6935 47.142 92.8575 45.522 92.8575 45.522C92.0475 44.82 91.1835 44.118 90.3195 43.47C87.2955 41.148 84.0015 39.366 80.4915 37.962C80.5456 37.962 50.2516 23.814 19.9576 37.962C19.9576 37.962 19.9576 37.962 19.9576 37.962Z",
    fill: "url(#gradient_13)",
    fillRule: "evenodd",
    transform: "translate(0 6.21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.66 0.0454025C12.042 -0.926601 0 14.0314 0 14.0314C0.27 14.7334 0.755997 16.6774 1.134 17.3254C2.592 20.0794 4.644 22.5094 7.344 23.9674C7.452 24.0214 7.56 24.0754 7.66801 24.1294C11.61 25.5334 15.822 25.4794 19.872 24.5074C22.356 23.9134 24.786 23.1034 27.27 22.5094C29.808 21.9154 34.992 20.0254 42.66 20.2414C42.66 20.2414 42.66 20.2414 42.66 20.2414C50.328 20.0254 55.62 21.8614 58.104 22.4554C60.588 23.0494 63.018 23.8594 65.502 24.4534C69.552 25.4254 73.764 25.4794 77.706 24.0754C77.814 24.0214 77.922 23.9674 78.03 23.9134C80.73 22.5094 82.782 20.0254 84.24 17.2714C84.564 16.6234 85.104 14.6794 85.374 13.9774C85.32 14.0314 72.306 -0.872597 42.66 0.0454025C42.66 0.0454025 42.66 0.0454025 42.66 0.0454025Z",
    fill: "url(#gradient_14)",
    fillRule: "evenodd",
    transform: "translate(7.537 37.863)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.02661 37.5002C1.02661 37.4462 0.432603 35.7722 3.6726 24.1622C3.6726 24.1622 4.53661 23.3522 4.53661 23.3522C1.4046 34.5842 1.56661 37.2302 1.56661 37.3382C1.56661 37.3382 1.02661 37.5002 1.02661 37.5002C1.02661 37.5002 1.02661 37.5002 1.02661 37.5002ZM84.9423 37.5002C84.9423 37.4462 85.5363 35.7722 82.2963 24.1622C82.2963 24.1622 81.4323 23.3522 81.4323 23.3522C84.5643 34.5842 84.4023 37.2302 84.4023 37.3382C84.4023 37.3382 84.9423 37.5002 84.9423 37.5002C84.9423 37.5002 84.9423 37.5002 84.9423 37.5002ZM44.3342 0.0240002C44.3342 0.0240002 44.3342 0.0240002 44.2802 0.0240002C44.2802 0.0240002 44.3342 0.0240002 44.3342 0.0240002C43.0922 -0.0299988 41.6342 0.0240002 41.6342 0.0240002C20.2502 4.668 21.9782 28.158 21.9782 28.374C21.9782 28.374 22.5722 28.32 22.5722 28.32C22.5722 28.104 21.7082 4.614 42.9842 0.240001C64.3142 4.56 63.4502 28.05 63.3962 28.32C63.3962 28.32 63.9902 28.374 63.9902 28.374C63.9902 28.158 65.7182 4.668 44.3342 0.0240002C44.3342 0.0240002 44.3342 0.0240002 44.3342 0.0240002ZM42.93 31.344C42.93 31.344 42.93 31.344 42.93 31.344C42.93 31.344 42.876 31.344 42.93 31.344C42.876 31.344 42.876 31.344 42.93 31.344C42.93 31.344 42.93 31.344 42.93 31.344C11.07 31.344 0.107998 45.33 0 45.438C0 45.438 0.485997 45.762 0.485997 45.762C0.593995 45.6 11.394 31.884 42.93 31.884C74.466 31.884 85.266 45.6 85.374 45.762C85.374 45.762 85.86 45.438 85.86 45.438C85.698 45.33 74.736 31.344 42.93 31.344C42.93 31.344 42.93 31.344 42.93 31.344Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(7.268 6.24)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.035 -0.27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 163.836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.74 28.62L0 16.146L12.042 0L28.782 12.474L16.74 28.62Z",
    fill: "url(#gradient_15)",
    fillRule: "evenodd",
    transform: "translate(59.428 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6297 90.6397C19.6297 90.6397 2.02573 77.5178 2.02573 77.5178C-0.188266 75.8438 -0.674267 72.7118 0.999733 70.4977C0.999733 70.4977 52.0297 2.02574 52.0297 2.02574C53.7037 -0.188262 56.8357 -0.674258 59.0497 0.999745C59.0497 0.999745 76.6537 14.1217 76.6537 14.1217C78.8678 15.7957 79.3538 18.9277 77.6797 21.1417C77.6797 21.1417 26.7037 89.6137 26.7037 89.6137C25.0297 91.8277 21.8977 92.3137 19.6297 90.6397C19.6297 90.6397 19.6297 90.6397 19.6297 90.6397Z",
    fill: "url(#gradient_16)",
    fillRule: "evenodd",
    transform: "translate(0 14.714)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.912 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 86.3992C0 38.6822 38.6822 0 86.3992 0C134.116 0 172.798 38.6822 172.798 86.3992C172.798 134.116 134.116 172.798 86.3992 172.798C38.6822 172.798 0 134.116 0 86.3992Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 0.2,
    transform: "translate(12.361 12.298)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7655 14.4183C145.313 14.4183 183.059 52.1643 183.059 98.7123C183.059 145.26 145.313 183.006 98.7655 183.006C52.2175 183.006 14.4715 145.26 14.4715 98.7123C14.4715 52.1643 52.2175 14.4183 98.7655 14.4183M98.766 0C85.428 0 72.522 2.592 60.318 7.776C48.546 12.744 38.016 19.872 28.944 28.944C19.872 38.016 12.744 48.546 7.776 60.318C2.646 72.522 0 85.428 0 98.766C0 112.104 2.592 125.01 7.776 137.214C12.744 148.986 19.872 159.516 28.944 168.588C38.016 177.66 48.546 184.788 60.318 189.756C72.522 194.886 85.428 197.532 98.766 197.532C112.104 197.532 125.01 194.94 137.214 189.756C148.986 184.788 159.516 177.66 168.588 168.588C177.66 159.516 184.788 148.986 189.756 137.214C194.886 125.01 197.532 112.104 197.532 98.766C197.532 85.428 194.94 72.522 189.756 60.318C184.734 48.546 177.606 37.962 168.534 28.89C159.462 19.818 148.932 12.69 137.16 7.722C125.01 2.592 112.05 0 98.766 0C98.766 0 98.766 0 98.766 0C98.766 0 98.766 0 98.766 0Z",
    fill: "url(#gradient_17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4 0C38.664 0 0 38.664 0 86.4C0 134.136 38.664 172.8 86.4 172.8C134.136 172.8 172.8 134.136 172.8 86.4C172.8 38.664 134.082 0 86.4 0C86.4 0 86.4 0 86.4 0ZM86.4004 170.694C39.8524 170.694 2.10642 132.948 2.10642 86.3999C2.10642 39.8519 39.8524 2.10593 86.4004 2.10593C132.948 2.10593 170.694 39.8519 170.694 86.3999C170.694 132.948 132.948 170.694 86.4004 170.694C86.4004 170.694 86.4004 170.694 86.4004 170.694Z",
    fill: "url(#gradient_18)",
    transform: "translate(12.366 12.312)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthiquinInvestigation);
export default __webpack_public_path__ + "static/media/ethiquin-investigation.a07c52b5bcd6e714c4b233f3ed50109b.svg";
export { ForwardRef as ReactComponent };